(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/create-reset-positions.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/create-reset-positions.js');
"use strict";


const createResetPositions = (createSetCenterTween, createSetRightTween) => slidesList => new Promise((resolve, reject) => {
  if (!slidesList || slidesList.length < 2) {
    reject(new Error('slideList must contain atleast 2 elements'));
  }
  const tl = gsap.timeline();
  const sll = slidesList.length;
  tl.add(createSetCenterTween(slidesList[0]), 0);
  for (let i = 1; i < sll; i++) {
    tl.add(createSetRightTween(slidesList[i]), 0);
  }
  tl.eventCallback('onComplete', () => {
    resolve();
  }).play();
});
setGlobal('svs.components.onboarding.slides.animations.createResetPositions', createResetPositions);

 })(window);